
export function prettyNumber(num: number | string): string {
    if (typeof num === 'string') {
        return num
    }
    return (Math.round(Number(num) * 100) / 100).toLocaleString('en-US').replaceAll(",", "'");
}

